<template>
  <div class="plots-component">
    <div class="title">
      <span>Сплошной перечет</span>
    </div>
    <div>
      <span
        >Количество деревьев:
        {{ plotList.length ? plotList[0].trees_count : 0 }}</span
      >
    </div>

    <button @click="openModalTrees1" class="tree-list-btn">
      {{
        plotList.length && plotList[0].trees_count === "0"
          ? "Создать перечет"
          : "Открыть перечет"
      }}
    </button>
    <button
      class="toggle-recount-btn"
      v-if="plotList.length"
      @click="tggleRecount"
      :disabled="!actLpoIsDraft"
    >
      {{
        recountIsOpen
          ? "Перейти к внесению данных о модельных деревьях для установления разряда высот"
          : "Разблокировать перечет для редактирования"
      }}
    </button>

    <TreesModal :isOpen.sync="treesModalIsOpen" @hide="onHide" />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

import TreesModal from "./Recount__trees/TreesModal";

export default {
  name: "PlotsSolid",
  components: {
    TreesModal,
  },
  data: () => ({
    addMode: false,

    editedPlotNum: -1,
    editedPlot: null,

    treesModalIsOpen: false,
  }),
  computed: {
    actLpoIsDraft() {
      return this.$store.getters["lpoData/actLpoIsDraft"];
    },

    lpo() {
      return this.$store.state.selectedLpo.lpo;
    },

    ...mapState("selectedLpo/recount", {
      plotList: (state) => state["plotList"],
      treeList: (state) => state["treeList"],
    }),

    ...mapGetters("selectedLpo/recount", ["recountIsOpen"]),
  },
  methods: {
    onHide() {
      this.updatePlotList(this.lpo.lpo_id);
    },

    openModalTrees1() {
      this.treesModalIsOpen = true;
    },

    async tggleRecount() {
      const LayerIsCorrect = await this.checkIsLayerCorrect();

      if (this.recountIsOpen && LayerIsCorrect?.is_correct === "f") {
        this.$toast.add({
          severity: "warn",
          detail:
            "Условия для выделения второго яруса не выполнены (полнота менее 0,3)!",
          life: 10000,
        });
        return;
      }

      this.toggleRecount(this.lpo.lpo_id).then((res) => {
        this.updatePlotList(this.lpo.lpo_id);
      });
    },

    ...mapActions("selectedLpo/recount", [
      "updatePlotList",
      "toggleRecount",
      "checkIsLayerCorrect",
    ]),
  },
};
</script>

<style scoped>
.tree-list-btn {
  margin-right: 10px;
}

.title {
  font-size: 1rem;
  font-weight: bold;
  font-style: italic;
  margin-bottom: 10px;
}

.toggle-recount-btn {
  margin-top: 20px;
}
</style>
